import type { VoiceEvidenceSource } from '../../../contracts/voice-protocol';
import type { EvidenceInfoCard } from '../workspace/workspace.types';

/** Stable info-card id so streaming Evidence patches update in place. */
export const evidenceInfoCardId = (callId: string): string => `evidence:${callId.trim()}`;

export type EvidenceInfoCardInput = {
  callId: string;
  text?: string;
  sources?: VoiceEvidenceSource[];
  /** Preserve feed order when updating an existing card. */
  ts?: number;
};

/**
 * Map a callId-merged Evidence timeline entry into a workspace
 * {@link EvidenceInfoCard}. Returns null when there is nothing renderable
 * (empty text and no sources).
 */
export const mapEvidenceToInfoCard = (
  input: EvidenceInfoCardInput
): EvidenceInfoCard | null => {
  const callId = input.callId.trim();
  if (!callId) return null;

  const text = input.text?.trim() ?? '';
  const sources = (input.sources ?? []).filter(
    (s) => s.title?.trim() || s.url?.trim() || s.domain?.trim()
  );
  if (!text && sources.length === 0) return null;

  return {
    kind: 'evidence',
    id: evidenceInfoCardId(callId),
    text,
    ...(sources.length > 0 ? { sources } : {}),
    ts: input.ts ?? Date.now(),
  };
};
